import { MessageContentEntity } from "@/indexedDB/types";
import ParentMediaAttachment from "./ParentMediaAttachment";
import ParentFileAttachment from "./ParentFileAttachment";

type Props = {
  messageId: string;
  messageTimestamp: string;
  chatId: string;
  messageContent: MessageContentEntity;
};

export default function ParentMessageAttachment({
  messageId,
  messageTimestamp,
  chatId,
  messageContent,
}: Props) {
  return (
    <div className="shrink-0">
      {messageContent.media && (
        <ParentMediaAttachment
          messageId={messageId}
          messageTimestamp={messageTimestamp}
          chatId={chatId}
          attachment={messageContent.media}
        />
      )}
      {messageContent.file && (
        <div>
          <ParentFileAttachment
            messageId={messageId}
            chatId={chatId}
            attachment={messageContent.file}
          />
        </div>
      )}
      {/* {messageContent.voice && (
        <CirclePlay strokeWidth={1} className="size-9" />
      )} */}
    </div>
  );
}
